import { getPages } from './getPages';
import { getPageUrl } from './getPageUrl';

export function getPageOptions(currentPage: number, maxPage: number, originalUrl: string) {
  return getPages(currentPage, maxPage).map(({ text, value }) => ({
    label: text,
    value,
    url: getPageUrl(value, originalUrl),
  }));
}
